import {
    Box,
    Flex,
    HStack,
    IconButton,
    Link,
    Image,
    Container,
    Collapsible,
} from "@chakra-ui/react"
import { FaInstagram, FaBars, FaTimes } from "react-icons/fa"
import { useState, useEffect } from "react"

export default function Navbar() {
    const [isOpen, setIsOpen] = useState(false)
    const [activeSection, setActiveSection] = useState("home")

    const navLinks = ["Home", "About Us", "Gallery", "Contact"]

    useEffect(() => {
        const handleScroll = () => {
            const scrollPosition = window.scrollY + 100 // Adding offset for better detection

            // Get all sections and their positions
            const sections = navLinks.map(link => {
                const id = link.toLowerCase().replaceAll(' ', '')
                const element = document.getElementById(id)
                return { id, element }
            }).filter(({ element }) => element !== null)

            // Determine which section is currently in view
            for (const { id, element } of sections) {
                const { offsetTop, offsetHeight } = element
                if (scrollPosition >= offsetTop && scrollPosition < offsetTop + offsetHeight) {
                    setActiveSection(id)
                    break
                }
            }
        }

        // Add scroll event listener
        window.addEventListener('scroll', handleScroll)
        
        // Check on initial load
        handleScroll()

        // Cleanup
        return () => window.removeEventListener('scroll', handleScroll)
    }, [])

    return (
        <Box bg="#131416" position="fixed" top="0" width="100%" zIndex="1000" boxShadow="sm">
            <Container maxW="container.xl" px={{ base: 4, md: 8 }}>
                <Flex h="80px" alignItems="center" justifyContent="space-between">
                    {/* Left: Logo */}
                    <Box>
                        <Image
                            src="/chroma_logo.png"
                            alt="Chroma Detailing Logo"
                            width={{ base: "160px", md: "240px" }}
                        />
                    </Box>

                    {/* Center: Desktop Nav Links */}
                    <HStack
                        as="nav"
                        spacing={4}
                        display={{ base: "none", md: "flex" }}
                        ml={4}
                        flex="1"
                    >
                        {navLinks.map((item) => {
                            const linkId = item.toLowerCase().replaceAll(' ', '')
                            return (
                                <Link
                                    key={item}
                                    href={`#${linkId}`}
                                    color="white"
                                    fontWeight="medium"
                                    px={3}
                                    py={2}
                                    borderRadius="md"
                                    transition="all 0.2s ease-in-out"
                                    position="relative"
                                    _hover={{
                                        textDecoration: "none",
                                        bg: "gray.700",
                                        boxShadow: "md",
                                    }}
                                    _after={{
                                        content: '""',
                                        position: 'absolute',
                                        bottom: '0',
                                        left: '50%',
                                        transform: 'translateX(-50%)',
                                        width: activeSection === linkId ? '70%' : '0',
                                        height: '2px',
                                        bg: 'white',
                                        transition: 'width 0.3s ease',
                                    }}
                                >
                                    {item}
                                </Link>
                            )
                        })}
                    </HStack>

                    {/* Right: Desktop Instagram Icon */}
                    <HStack spacing={2} display={{ base: "none", md: "flex" }}>
                        <IconButton
                            as="a"
                            href="https://www.instagram.com/chromadetail"
                            aria-label="Instagram"
                            variant="ghost"
                            color="white"
                            target="_blank"
                            _hover={{ bg: "gray.700" }}
                        >
                            <FaInstagram />
                        </IconButton>
                    </HStack>

                    {/* Mobile Burger Button */}
                    <Collapsible.Root open={isOpen}>
                        <Collapsible.Trigger asChild>
                            <IconButton
                                display={{ base: "flex", md: "none" }}
                                onClick={() => setIsOpen((prev) => !prev)}
                                variant="ghost"
                                aria-label="Toggle Navigation"
                                color="white"
                                _hover={{ bg: "gray.700" }}
                            >
                                { isOpen ? (
                                    <FaTimes />
                                ) : (
                                    <FaBars />
                                )}
                            </IconButton>
                        </Collapsible.Trigger>

                        <Collapsible.Content>
                            <Box
                                display={{ base: "flex", md: "none" }}
                                flexDirection="column"
                                bg="#131416"
                                px={4}
                                pb={6}
                                pt={4}
                                position="absolute"
                                top="80px"
                                left="0"
                                right="0"
                                zIndex="999"
                            >
                                {["Home", "About Us", "Gallery", "Contact"].map((item) => (
                                    <Link
                                        key={item}
                                        href={`#${item.toLowerCase().replaceAll(' ', '')}`}
                                        onClick={() => setIsOpen(false)}
                                        color="white"
                                        fontWeight="medium"
                                        px={3}
                                        py={2}
                                        borderRadius="md"
                                        transition="all 0.2s ease-in-out"
                                        _hover={{
                                            textDecoration: "none",
                                            bg: "gray.700",
                                            boxShadow: "md",
                                        }}
                                    >
                                        {item}
                                    </Link>
                                ))}
                                <IconButton
                                    as="a"
                                    href="https://www.instagram.com/chromadetail"
                                    aria-label="Instagram"
                                    variant="ghost"
                                    color="white"
                                    target="_blank"
                                    textAlign="left"
                                    px={2.5}
                                    justifyContent="left"
                                    _hover={{ bg: "gray.700" }}
                                >
                                    <FaInstagram />
                                </IconButton>
                            </Box>
                        </Collapsible.Content>
                    </Collapsible.Root>
                </Flex>
            </Container>
        </Box>
    )
}